// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a1388b97","455":"2b4ec453","977":"375d8c7f"}[chunkId] + ".chunk.js";
};